export enum PortletSizeState {
    Maximized = 1,
    Normal = 2
}